<!--耿彪增加省市县自定义组件-->
<template>
  <div class="treebox">
    <ul>
      <li v-for="(item,i) in region" :key="i" :class="regionactivelen==i?'regionactive':''" @click="regionClick(item,i)">{{item.name}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      region: [
        { name: "省", id: 0 },
        { name: "市", id: 1 },
        { name: "县", id: 2 },
      ],
      regionactivelen: 0,
    };
  },
  mounted() {},
  watch: {},
  methods: {
    regionClick(item, i) {
      this.regionactivelen = i;
      this.$emit("citySelected", item);
    },
  },
};
</script>
<style scoped>
</style>